import { render, staticRenderFns } from "./EnvelopeList.vue?vue&type=template&id=78a42752&scoped=true"
import script from "./EnvelopeList.vue?vue&type=script&lang=js"
export * from "./EnvelopeList.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeList.vue?vue&type=style&index=0&id=78a42752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a42752",
  null
  
)

export default component.exports